$(document).ready(function(){
  setTimeout(function() {
  $('.related-products .related-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow: '<button class="custom_arrow1 slick-prev slick-arrow" aria-label="Previous slide"><svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.469669 6.53033C0.176777 6.23744 0.176777 5.76256 0.469669 5.46967L5.24264 0.6967C5.53553 0.403807 6.01041 0.403807 6.3033 0.6967C6.59619 0.989593 6.59619 1.46447 6.3033 1.75736L2.06066 6L6.3033 10.2426C6.59619 10.5355 6.59619 11.0104 6.3033 11.3033C6.01041 11.5962 5.53553 11.5962 5.24264 11.3033L0.469669 6.53033ZM17 6.75L1 6.75L1 5.25L17 5.25L17 6.75Z" fill="white"></path></svg></button>',
  nextArrow: '<button class="custom_arrow1 slick-next slick-arrow" aria-label="Next slide"><svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.5303 6.53033C16.8232 6.23744 16.8232 5.76256 16.5303 5.46967L11.7574 0.6967C11.4645 0.403807 10.9896 0.403807 10.6967 0.6967C10.4038 0.989593 10.4038 1.46447 10.6967 1.75736L14.9393 6L10.6967 10.2426C10.4038 10.5355 10.4038 11.0104 10.6967 11.3033C10.9896 11.5962 11.4645 11.5962 11.7574 11.3033L16.5303 6.53033ZM-6.55671e-08 6.75L16 6.75L16 5.25L6.55671e-08 5.25L-6.55671e-08 6.75Z" fill="white"></path></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        centerMode: true,
        centerPadding: '70px',
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});  
    }, 3000);
});


$('.testimonials-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
    prevArrow: '<button class="custom_arrow1 slick-prev slick-arrow" aria-label="Previous slide"><svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.469669 6.53033C0.176777 6.23744 0.176777 5.76256 0.469669 5.46967L5.24264 0.6967C5.53553 0.403807 6.01041 0.403807 6.3033 0.6967C6.59619 0.989593 6.59619 1.46447 6.3033 1.75736L2.06066 6L6.3033 10.2426C6.59619 10.5355 6.59619 11.0104 6.3033 11.3033C6.01041 11.5962 5.53553 11.5962 5.24264 11.3033L0.469669 6.53033ZM17 6.75L1 6.75L1 5.25L17 5.25L17 6.75Z" fill="white"></path></svg></button>',
  nextArrow: '<button class="custom_arrow1 slick-next slick-arrow" aria-label="Next slide"><svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.5303 6.53033C16.8232 6.23744 16.8232 5.76256 16.5303 5.46967L11.7574 0.6967C11.4645 0.403807 10.9896 0.403807 10.6967 0.6967C10.4038 0.989593 10.4038 1.46447 10.6967 1.75736L14.9393 6L10.6967 10.2426C10.4038 10.5355 10.4038 11.0104 10.6967 11.3033C10.9896 11.5962 11.4645 11.5962 11.7574 11.3033L16.5303 6.53033ZM-6.55671e-08 6.75L16 6.75L16 5.25L6.55671e-08 5.25L-6.55671e-08 6.75Z" fill="white"></path></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});  

$('.video-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
   prevArrow: '<button class="custom_arrow1 slick-prev slick-arrow" aria-label="Previous slide"><svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.469669 6.53033C0.176777 6.23744 0.176777 5.76256 0.469669 5.46967L5.24264 0.6967C5.53553 0.403807 6.01041 0.403807 6.3033 0.6967C6.59619 0.989593 6.59619 1.46447 6.3033 1.75736L2.06066 6L6.3033 10.2426C6.59619 10.5355 6.59619 11.0104 6.3033 11.3033C6.01041 11.5962 5.53553 11.5962 5.24264 11.3033L0.469669 6.53033ZM17 6.75L1 6.75L1 5.25L17 5.25L17 6.75Z" fill="white"></path></svg></button>',
  nextArrow: '<button class="custom_arrow1 slick-next slick-arrow" aria-label="Next slide"><svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.5303 6.53033C16.8232 6.23744 16.8232 5.76256 16.5303 5.46967L11.7574 0.6967C11.4645 0.403807 10.9896 0.403807 10.6967 0.6967C10.4038 0.989593 10.4038 1.46447 10.6967 1.75736L14.9393 6L10.6967 10.2426C10.4038 10.5355 10.4038 11.0104 10.6967 11.3033C10.9896 11.5962 11.4645 11.5962 11.7574 11.3033L16.5303 6.53033ZM-6.55671e-08 6.75L16 6.75L16 5.25L6.55671e-08 5.25L-6.55671e-08 6.75Z" fill="white"></path></svg></button>',
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 999,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});  


$('.homepage-slider-one').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow: '<button class="custom_arrow1 slick-prev slick-arrow" aria-label="Previous slide"><svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.469669 6.53033C0.176777 6.23744 0.176777 5.76256 0.469669 5.46967L5.24264 0.6967C5.53553 0.403807 6.01041 0.403807 6.3033 0.6967C6.59619 0.989593 6.59619 1.46447 6.3033 1.75736L2.06066 6L6.3033 10.2426C6.59619 10.5355 6.59619 11.0104 6.3033 11.3033C6.01041 11.5962 5.53553 11.5962 5.24264 11.3033L0.469669 6.53033ZM17 6.75L1 6.75L1 5.25L17 5.25L17 6.75Z" fill="white"></path></svg></button>',
  nextArrow: '<button class="custom_arrow1 slick-next slick-arrow" aria-label="Next slide"><svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.5303 6.53033C16.8232 6.23744 16.8232 5.76256 16.5303 5.46967L11.7574 0.6967C11.4645 0.403807 10.9896 0.403807 10.6967 0.6967C10.4038 0.989593 10.4038 1.46447 10.6967 1.75736L14.9393 6L10.6967 10.2426C10.4038 10.5355 10.4038 11.0104 10.6967 11.3033C10.9896 11.5962 11.4645 11.5962 11.7574 11.3033L16.5303 6.53033ZM-6.55671e-08 6.75L16 6.75L16 5.25L6.55671e-08 5.25L-6.55671e-08 6.75Z" fill="white"></path></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        centerMode: true,
        centerPadding: '70px',
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
}); 


  
$('.homepage-slider-two').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
    prevArrow: '<button class="custom_arrow1 slick-prev slick-arrow" aria-label="Previous slide"><svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.469669 6.53033C0.176777 6.23744 0.176777 5.76256 0.469669 5.46967L5.24264 0.6967C5.53553 0.403807 6.01041 0.403807 6.3033 0.6967C6.59619 0.989593 6.59619 1.46447 6.3033 1.75736L2.06066 6L6.3033 10.2426C6.59619 10.5355 6.59619 11.0104 6.3033 11.3033C6.01041 11.5962 5.53553 11.5962 5.24264 11.3033L0.469669 6.53033ZM17 6.75L1 6.75L1 5.25L17 5.25L17 6.75Z" fill="white"></path></svg></button>',
  nextArrow: '<button class="custom_arrow1 slick-next slick-arrow" aria-label="Next slide"><svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.5303 6.53033C16.8232 6.23744 16.8232 5.76256 16.5303 5.46967L11.7574 0.6967C11.4645 0.403807 10.9896 0.403807 10.6967 0.6967C10.4038 0.989593 10.4038 1.46447 10.6967 1.75736L14.9393 6L10.6967 10.2426C10.4038 10.5355 10.4038 11.0104 10.6967 11.3033C10.9896 11.5962 11.4645 11.5962 11.7574 11.3033L16.5303 6.53033ZM-6.55671e-08 6.75L16 6.75L16 5.25L6.55671e-08 5.25L-6.55671e-08 6.75Z" fill="white"></path></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        centerMode: true,
        centerPadding: '70px',
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});  


$('.homepage-slider-three').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
    prevArrow: '<button class="custom_arrow1 slick-prev slick-arrow" aria-label="Previous slide"><svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.469669 6.53033C0.176777 6.23744 0.176777 5.76256 0.469669 5.46967L5.24264 0.6967C5.53553 0.403807 6.01041 0.403807 6.3033 0.6967C6.59619 0.989593 6.59619 1.46447 6.3033 1.75736L2.06066 6L6.3033 10.2426C6.59619 10.5355 6.59619 11.0104 6.3033 11.3033C6.01041 11.5962 5.53553 11.5962 5.24264 11.3033L0.469669 6.53033ZM17 6.75L1 6.75L1 5.25L17 5.25L17 6.75Z" fill="white"></path></svg></button>',
  nextArrow: '<button class="custom_arrow1 slick-next slick-arrow" aria-label="Next slide"><svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.5303 6.53033C16.8232 6.23744 16.8232 5.76256 16.5303 5.46967L11.7574 0.6967C11.4645 0.403807 10.9896 0.403807 10.6967 0.6967C10.4038 0.989593 10.4038 1.46447 10.6967 1.75736L14.9393 6L10.6967 10.2426C10.4038 10.5355 10.4038 11.0104 10.6967 11.3033C10.9896 11.5962 11.4645 11.5962 11.7574 11.3033L16.5303 6.53033ZM-6.55671e-08 6.75L16 6.75L16 5.25L6.55671e-08 5.25L-6.55671e-08 6.75Z" fill="white"></path></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        centerMode: true,
        centerPadding: '70px',
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

  
$('.Collection-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
    prevArrow: '<button class="custom_arrow1 slick-prev slick-arrow" aria-label="Previous slide"><svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.469669 6.53033C0.176777 6.23744 0.176777 5.76256 0.469669 5.46967L5.24264 0.6967C5.53553 0.403807 6.01041 0.403807 6.3033 0.6967C6.59619 0.989593 6.59619 1.46447 6.3033 1.75736L2.06066 6L6.3033 10.2426C6.59619 10.5355 6.59619 11.0104 6.3033 11.3033C6.01041 11.5962 5.53553 11.5962 5.24264 11.3033L0.469669 6.53033ZM17 6.75L1 6.75L1 5.25L17 5.25L17 6.75Z" fill="white"></path></svg></button>',
  nextArrow: '<button class="custom_arrow1 slick-next slick-arrow" aria-label="Next slide"><svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.5303 6.53033C16.8232 6.23744 16.8232 5.76256 16.5303 5.46967L11.7574 0.6967C11.4645 0.403807 10.9896 0.403807 10.6967 0.6967C10.4038 0.989593 10.4038 1.46447 10.6967 1.75736L14.9393 6L10.6967 10.2426C10.4038 10.5355 10.4038 11.0104 10.6967 11.3033C10.9896 11.5962 11.4645 11.5962 11.7574 11.3033L16.5303 6.53033ZM-6.55671e-08 6.75L16 6.75L16 5.25L6.55671e-08 5.25L-6.55671e-08 6.75Z" fill="white"></path></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        centerMode: true,
        centerPadding: '70px',
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});  



$('.youtube-video-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
   prevArrow: '<button class="custom_arrow1 slick-prev slick-arrow" aria-label="Previous slide"><svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.469669 6.53033C0.176777 6.23744 0.176777 5.76256 0.469669 5.46967L5.24264 0.6967C5.53553 0.403807 6.01041 0.403807 6.3033 0.6967C6.59619 0.989593 6.59619 1.46447 6.3033 1.75736L2.06066 6L6.3033 10.2426C6.59619 10.5355 6.59619 11.0104 6.3033 11.3033C6.01041 11.5962 5.53553 11.5962 5.24264 11.3033L0.469669 6.53033ZM17 6.75L1 6.75L1 5.25L17 5.25L17 6.75Z" fill="white"></path></svg></button>',
  nextArrow: '<button class="custom_arrow1 slick-next slick-arrow" aria-label="Next slide"><svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.5303 6.53033C16.8232 6.23744 16.8232 5.76256 16.5303 5.46967L11.7574 0.6967C11.4645 0.403807 10.9896 0.403807 10.6967 0.6967C10.4038 0.989593 10.4038 1.46447 10.6967 1.75736L14.9393 6L10.6967 10.2426C10.4038 10.5355 10.4038 11.0104 10.6967 11.3033C10.9896 11.5962 11.4645 11.5962 11.7574 11.3033L16.5303 6.53033ZM-6.55671e-08 6.75L16 6.75L16 5.25L6.55671e-08 5.25L-6.55671e-08 6.75Z" fill="white"></path></svg></button>',
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


$('.packout-page-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
    prevArrow: '<button class="custom_arrow1 slick-prev slick-arrow" aria-label="Previous slide"><svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.469669 6.53033C0.176777 6.23744 0.176777 5.76256 0.469669 5.46967L5.24264 0.6967C5.53553 0.403807 6.01041 0.403807 6.3033 0.6967C6.59619 0.989593 6.59619 1.46447 6.3033 1.75736L2.06066 6L6.3033 10.2426C6.59619 10.5355 6.59619 11.0104 6.3033 11.3033C6.01041 11.5962 5.53553 11.5962 5.24264 11.3033L0.469669 6.53033ZM17 6.75L1 6.75L1 5.25L17 5.25L17 6.75Z" fill="white"></path></svg></button>',
  nextArrow: '<button class="custom_arrow1 slick-next slick-arrow" aria-label="Next slide"><svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.5303 6.53033C16.8232 6.23744 16.8232 5.76256 16.5303 5.46967L11.7574 0.6967C11.4645 0.403807 10.9896 0.403807 10.6967 0.6967C10.4038 0.989593 10.4038 1.46447 10.6967 1.75736L14.9393 6L10.6967 10.2426C10.4038 10.5355 10.4038 11.0104 10.6967 11.3033C10.9896 11.5962 11.4645 11.5962 11.7574 11.3033L16.5303 6.53033ZM-6.55671e-08 6.75L16 6.75L16 5.25L6.55671e-08 5.25L-6.55671e-08 6.75Z" fill="white"></path></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        centerMode: true,
        centerPadding: '70px',
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
}); 



document.addEventListener("DOMContentLoaded", function () {
  function normalize(str) {
    return str
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9\-]/g, '');
  }

  const activeMenu = document.querySelector('.third-category.default');
  let activeIndex = 0;

  if (activeMenu) {
    const activeText = activeMenu.textContent || activeMenu.innerText;
    const activeKey = normalize(activeText);

    const slides = Array.from(document.querySelectorAll('.packout-box-data'));

    slides.forEach((el, index) => {
      const title = el.getAttribute('data-menu');
      const dataKey = normalize(title);

      if (dataKey === activeKey) {
        el.classList.add('active');
        activeIndex = index; // store index
      } else {
        el.classList.remove('active');
      }
    });
  }

  // Slick slider init
  const $slider = $('.packout-box-slider');

  $slider.slick({
    dots: false,
    infinite: true,
    speed: 300,
    prevArrow: '<button class="custom_arrow1 slick-prev slick-arrow" aria-label="Previous slide"><svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.469669 6.53033C0.176777 6.23744 0.176777 5.76256 0.469669 5.46967L5.24264 0.6967C5.53553 0.403807 6.01041 0.403807 6.3033 0.6967C6.59619 0.989593 6.59619 1.46447 6.3033 1.75736L2.06066 6L6.3033 10.2426C6.59619 10.5355 6.59619 11.0104 6.3033 11.3033C6.01041 11.5962 5.53553 11.5962 5.24264 11.3033L0.469669 6.53033ZM17 6.75L1 6.75L1 5.25L17 5.25L17 6.75Z" fill="white"></path></svg></button>',
    nextArrow: '<button class="custom_arrow1 slick-next slick-arrow" aria-label="Next slide"><svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.5303 6.53033C16.8232 6.23744 16.8232 5.76256 16.5303 5.46967L11.7574 0.6967C11.4645 0.403807 10.9896 0.403807 10.6967 0.6967C10.4038 0.989593 10.4038 1.46447 10.6967 1.75736L14.9393 6L10.6967 10.2426C10.4038 10.5355 10.4038 11.0104 10.6967 11.3033C10.9896 11.5962 11.4645 11.5962 11.7574 11.3033L16.5303 6.53033ZM-6.55671e-08 6.75L16 6.75L16 5.25L6.55671e-08 5.25L-6.55671e-08 6.75Z" fill="white"></path></svg></button>',
    slidesToShow: 4,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  setTimeout(function () {
    $slider.slick('slickGoTo', activeIndex); // Navigate to the active slide
  }, 100);
});


 document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".block-item").forEach((item) => {
      const video = item.querySelector(".custom-video");
      const button = item.querySelector(".video-toggle");
      const playIcon = button.querySelector(".play-icon");
      const pauseIcon = button.querySelector(".pause-icon");

      button.addEventListener("click", function () {
        if (video.paused) {
          video.play();
          playIcon.style.display = "none";
          pauseIcon.style.display = "inline";
        } else {
          video.pause();
          playIcon.style.display = "inline";
          pauseIcon.style.display = "none";
        }
      });
    });
  });



  function toggleFAQ(button) {
    var content = button.nextElementSibling;
    var faqItem = button.parentElement;
    if (content.style.display === "block") {
      content.style.display = "none";
      faqItem.classList.remove("active");
    } else {
      content.style.display = "block";
      faqItem.classList.add("active");
    }
  }

// document.addEventListener('DOMContentLoaded', function () {
//   const variantSelector = document.querySelector('form [name="id"]');
//   const gallery = document.querySelector('#Slider-Gallery-{{ section.id }}');

//   if (!variantSelector || !gallery) return;

//   let variantChanged = false;

//   variantSelector.addEventListener('change', function () {
//     if (variantChanged) return; // Prevent multiple reloads
//     variantChanged = true;

//     const selectedVariantId = this.value;
//     const url = new URL(window.location.href);
//     url.searchParams.set('variant', selectedVariantId);

//     fetch(url)
//       .then((res) => res.text())
//       .then((html) => {
//         const tempDiv = document.createElement('div');
//         tempDiv.innerHTML = html;

//         const newGallery = tempDiv.querySelector('#Slider-Gallery-{{ section.id }}');
//         if (newGallery) {
//           gallery.innerHTML = newGallery.innerHTML;
//         }
//       });
//   });
// });
document.addEventListener('DOMContentLoaded', function () {
  const variantSelector = document.querySelector('form [name="id"]');
  const gallery = document.querySelector(`#Slider-Gallery-${window.sectionId}`);

  if (!variantSelector || !gallery) return;

  let variantChanged = false;

  variantSelector.addEventListener('change', function () {
    if (variantChanged) return;
    variantChanged = true;

    const selectedVariantId = this.value;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', selectedVariantId);

    fetch(url)
      .then((res) => res.text())
      .then((html) => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        const newGallery = tempDiv.querySelector(`#Slider-Gallery-${window.sectionId}`);
        if (newGallery) {
          gallery.innerHTML = newGallery.innerHTML;
        }
      });
  });
});

 $('.promotion-section-slider').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow: '<button class="custom_arrow1 slick-prev slick-arrow" aria-label="Previous slide"><svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0.469669 6.53033C0.176777 6.23744 0.176777 5.76256 0.469669 5.46967L5.24264 0.6967C5.53553 0.403807 6.01041 0.403807 6.3033 0.6967C6.59619 0.989593 6.59619 1.46447 6.3033 1.75736L2.06066 6L6.3033 10.2426C6.59619 10.5355 6.59619 11.0104 6.3033 11.3033C6.01041 11.5962 5.53553 11.5962 5.24264 11.3033L0.469669 6.53033ZM17 6.75L1 6.75L1 5.25L17 5.25L17 6.75Z" fill="white"></path></svg></button>',
  nextArrow: '<button class="custom_arrow1 slick-next slick-arrow" aria-label="Next slide"><svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.5303 6.53033C16.8232 6.23744 16.8232 5.76256 16.5303 5.46967L11.7574 0.6967C11.4645 0.403807 10.9896 0.403807 10.6967 0.6967C10.4038 0.989593 10.4038 1.46447 10.6967 1.75736L14.9393 6L10.6967 10.2426C10.4038 10.5355 10.4038 11.0104 10.6967 11.3033C10.9896 11.5962 11.4645 11.5962 11.7574 11.3033L16.5303 6.53033ZM-6.55671e-08 6.75L16 6.75L16 5.25L6.55671e-08 5.25L-6.55671e-08 6.75Z" fill="white"></path></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 768,
      settings: {
        centerMode: true,
        centerPadding: '70px',
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
}); 